import React, { useRef, useEffect, useState, useContext } from 'react';

import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { getBalancePurchaseDetails } from '../../../API/PurchaseOrders/PurchaseOrderRequest';
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';
import Loader from '../../../Components/Loader/Loader';
import { toastShow } from '../../../Services/ToastService';
import { Toast } from 'primereact/toast';
import { AuthContext } from '../../../Context/AuthContext/AuthContext';
const AllPurchaseOrderDetailsOverlayPanel = ({ values, NuevaFila, close, habilitar }) => {
    const pd = useRef(null)
    const buttom = useRef(null)
    const toast = useRef(null)
    const [loading, setLoading] = useState(false);
    const [purchaseDetils, setPurchaseDetails] = useState([]);
    const [selected, setSelected] = useState([]);
    const {userAuth} = useContext(AuthContext)

    const obtenerDetallesPO = async () => {
        if (values?.IdPO > 0) {
            const tempoDetalles = await getBalancePurchaseDetails(values?.IdPO)

            if (tempoDetalles?.length > 0) {
                setPurchaseDetails(tempoDetalles)
            } else {
                toastShow(toast, 'error', ' No existen productos con balance de la orden seleccionada')
            }

        }

        setLoading(false)
    }

    const table = {
        Data: purchaseDetils,
        selected: selected,
        setSelected: setSelected,
        Columns: [
            {
                field: 'IdPurchaseOrderDetail',
                header: 'IdPurchaseDetails',
                headerEn: 'IdPurchaseDetails',
                width:60,
                className: 'Xsmall',
                hidden: userAuth.IdRol === 1
            },
            {
                field: 'CodigoProducto',
                header: 'Product Code',
                headerEn: 'Codigo Producto',
                className: 'small',
            },
            {
                field: 'NombreProducto',
                header: 'Producto ',
                headerEn: 'Product',
                className: 'XXlarge',
            },
            {
                field: 'UnitName',
                header: 'Unidad',
                headerEn: 'Unit',
                className: 'Xsmall',
            },
            {
                field: 'QtyOrdered',
                header: 'Cantidad',
                headerEn: 'QtyOrdered',
                className: 'Xsmall',
                Format: 'Currency',
                Sumary: 'sum'
            },

            {
                field: 'UnitPrice',
                header: 'UnitPrice',
                headerEn: 'UnitPrice',
                className: 'Xsmall',
                Format: 'Currency',
            },
            {
                field: 'Total',
                header: 'Total',
                headerEn: 'Total',
                className: 'Xsmall',
                Format: 'Currency',
                Sumary: 'sum'
            },
        ],
        onCellClicked: e => {
            let s =   selected.length == 0 ? [e?.data] : selected
            NuevaFila(s, values, e, pd)
            setSelected([])
        }
    }

    const openOver = (e) => {
        setLoading(true)
        pd.current.toggle(e)
        obtenerDetallesPO()
    }

    

    return (
        <div>
            <Button icon='pi pi-plus' onClick={(e) => openOver(e)} style={{ backgroundColor: "slategray", width: 40, height: 35 }} disabled={!habilitar}/>
            <OverlayPanel ref={pd} showCloseIcon dismissable={false} className='OverPanelProductos' onHide={close} >
                <Toast ref={toast} />
                <Loader loading={loading} querySelector={'#DetallesPO'} />
                <div style={{ width: 1000, height: 350 }} id='DetallesPO'>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </div>
    )
}

export default AllPurchaseOrderDetailsOverlayPanel
